import classNames from "classnames";

import styles from "./UI.module.css";

/* Replacements for the four @mui/icons-material glyphs this app used.
 *
 * Path data is the same Material Design artwork (Apache-2.0) the MUI icons ship,
 * so the rendered glyphs are unchanged. `fill="currentColor"` is a presentation
 * attribute, not a style attribute, so it is unaffected by `style-src 'self'`.
 */

function Icon({ children, className, title, viewBox = "0 0 24 24" }) {
    return (
        <svg
            aria-hidden={title ? undefined : true}
            className={classNames(styles.icon, className)}
            fill="currentColor"
            focusable="false"
            role={title ? "img" : undefined}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
        >
            {title ? <title>{title}</title> : null}
            {children}
        </svg>
    );
}

export function GoogleIcon({ className }) {
    return (
        <Icon className={className}>
            <path d="M12.545,10.239v3.821h5.445c-0.712,2.315-2.647,3.972-5.445,3.972c-3.332,0-6.033-2.701-6.033-6.032s2.701-6.032,6.033-6.032c1.498,0,2.866,0.549,3.921,1.453l2.814-2.814C17.503,2.988,15.139,2,12.545,2C7.021,2,2.543,6.477,2.543,12s4.478,10,10.002,10c8.396,0,10.249-7.85,9.426-11.748L12.545,10.239z" />
        </Icon>
    );
}

export function MicrosoftIcon({ className }) {
    return (
        <Icon className={className}>
            <path d="M2 3h9v9H2V3m9 19H2v-9h9v9M21 3v9h-9V3h9m0 19h-9v-9h9v9Z" />
        </Icon>
    );
}

export function VisibilityIcon({ className }) {
    return (
        <Icon className={className}>
            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3" />
        </Icon>
    );
}

export function VisibilityOffIcon({ className }) {
    return (
        <Icon className={className}>
            <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z" />
        </Icon>
    );
}
